<div class="breadcrumb-list">
  <div class="container">
      <ul>
          <li *ngFor="let l of links;let last=last;" [ngClass]="{'last':last}"> 
              <a [routerLink]="l.link" *ngIf="!last" class="text" (click)="_navigate(l.link)">
                  {{l.text}}
              </a> 
              <span *ngIf="last" class="text">{{l.text}}</span>
              <span *ngIf="!last" class="separator"><i class="fa-solid fa-angle-right"></i></span> 
          </li>
      </ul>   
  </div> 
</div>    